import { useState } from 'react';
import { differenceInDays, endOfDay, startOfDay, subDays } from 'date-fns';
import { breakpoints } from 'styles';
import { useDateNow, useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Box } from 'components/common/box';
import { DateRangeSelector, LineChart } from 'components/common/charts';
import { StatItem } from 'components/common/stats';

import { GetTeamLoginsRes } from 'shared-types/responses';

const MyTeamLogins = () => {
  const { dateNow } = useDateNow();

  const { messages, user } = useReduxState();

  const [fromDate, setFromDate] = useState(
    startOfDay(subDays(dateNow, 30)).toISOString()
  );
  const [toDate, setToDate] = useState(endOfDay(new Date()).toISOString());
  const [range, setRange] = useState<'day' | 'week' | 'month'>('day');

  const { data, loading } = useApiData<GetTeamLoginsRes>({
    url: `/admin/supervisors/${user?.id}/team-logins?fromDate=${fromDate}&toDate=${toDate}`,
    onlyIf: Boolean(user)
  });

  const chartData =
    data?.loginEntriesData?.map((item) => ({
      label: item.label,
      [messages.commonUsers]: item.count
    })) || [];

  const handleDateRangeChanged = (values: {
    fromDate: string;
    toDate: string;
    range: 'day' | 'week' | 'month';
  }) => {
    if (!values.range) {
      const diffInDays = differenceInDays(
        Date.parse(values.toDate),
        Date.parse(values.fromDate)
      );

      values.range =
        diffInDays > 182 ? 'month' : diffInDays > 42 ? 'week' : 'day';
    }

    setFromDate(values.fromDate);
    setToDate(values.toDate);
    setRange(values.range);
  };

  return (
    <div className="logins">
      <Box
        headerContent={
          <DateRangeSelector
            size="header"
            updateData={handleDateRangeChanged}
          />
        }
        headerContentWrap={true}
        loading={loading}
        padding={0}
        title={messages.commonLogins}
      >
        <div className="labels">
          <StatItem
            align="left"
            horizontal={true}
            label={messages.myTeamLogins}
            value={data?.loginEntriesUsersCount}
          />
        </div>
        <div className="chart">
          <LineChart
            data={chartData}
            height={200}
            xAxisDataKey="label"
            yAxisDataKey={messages.commonUsers}
          />
        </div>
      </Box>

      <style jsx>{`
        .labels {
          padding: 15px 15px 0px;
        }
        .chart {
          padding: 10px 15px;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .labels {
            padding: 20px 20px 0px;
          }
          .chart {
            padding: 10px 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default MyTeamLogins;
